import { render, staticRenderFns } from "./PopupChangePassowrd.vue?vue&type=template&id=7b0d54c8&scoped=true&lang=pug&"
import script from "./PopupChangePassowrd.vue?vue&type=script&lang=coffee&"
export * from "./PopupChangePassowrd.vue?vue&type=script&lang=coffee&"
import style0 from "./PopupChangePassowrd.vue?vue&type=style&index=0&id=7b0d54c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0d54c8",
  null
  
)

export default component.exports